export default "__VITE_ASSET__IcMO5kqF__"